import React from 'react'
import { Accordion, DimensionsContent } from '@sainsburys-tech/bolt'
import HabitatDimensions from './HabitatDimensions'
import getImageIndexWithFlag from '../../helpers/getImageIndexWithFlag'

import * as Styled from './HabitatDimensions.styles'
import { scrollToAccordion } from '../../helpers/openAccordion'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'

const HabitatDimensionsSection = dimensionDetails => {
  const { images, dimensions, isMTO } = dimensionDetails || {}
  const Header = <Styled.Heading>{isMTO ? 'Dimensions' : 'Dimensions & Details'}</Styled.Heading>
  const formatedImages = images.map(el => {
    return { src: el }
  })
  const lineDrawingIndex = getImageIndexWithFlag(formatedImages, 'E')

  if (lineDrawingIndex.length === 0 && !isMTO) {
    return null
  }

  const lineDrawing = images[lineDrawingIndex[0]]
  const dataTest = 'habitat-dimensions'

  const onAccordionInteraction = (index, show) => {
    if (show) {
      scrollToAccordion('#habitat-dimensions', isMTO)
    }
    // Adobe Analytics Tracking Code
    if (isMTO) {
      const adobeAnalytics = show ? pushEventAndTrack : () => {}
      adobeAnalytics({
        eventInfo: {
          eventName: 'pdp_showMore',
          eventAction: 'Dimensions'
        }
      })
    }
  }
  const accordionOptions = {
    title: Header,
    name: 'Habitat Dimensions',
    id: 'habitat-dimensions',
    'data-test': dataTest,
    index: 'habitat-dimensions',
    onClick: onAccordionInteraction
  }

  const dimensionProps = {
    dataTest,
    lineDrawing,
    dimensions
  }

  const dimensionsContentExists = dimensions && dimensions.attributes && Object.keys(dimensions.attributes).length > 0

  return (
    dimensionsContentExists && (
      <Accordion.Item as='h3' hasBorderBottom noAnimation isOpen={!isMTO} {...accordionOptions}>
        {isMTO ? (
          <DimensionsContent dimensions={{ ...dimensions.attributes }} media={{ images }} />
        ) : (
          <HabitatDimensions {...dimensionProps} />
        )}
      </Accordion.Item>
    )
  )
}

export default HabitatDimensionsSection
